/**
 * RGM Contests · Phase 1 — Criteria editor.
 * Presentational: parent owns state and PUT call.
 */
import React from "react";

export default function CriteriaEditor({ criteria = [], scale = { min: 1, max: 10 }, disabled = false, onChange }) {
  const update = (idx, patch) => onChange?.(criteria.map((c, i) => i === idx ? { ...c, ...patch } : c));
  const add = () => {
    if (criteria.length >= 6) return;
    onChange?.([...criteria, { criterion_id: `crit_${Math.random().toString(36).slice(2, 10)}`, label: "New criterion", weight: 1, order: criteria.length }]);
  };
  const remove = (idx) => onChange?.(criteria.filter((_, i) => i !== idx));
  return (
    <div className="space-y-2" data-testid="criteria-editor">
      {criteria.length === 0 && (
        <p className="text-[11px] text-gray-500" data-testid="criteria-empty">No criteria yet. Add 1–6 to enable judging.</p>
      )}
      {criteria.map((c, i) => (
        <div key={c.criterion_id || i} className="flex items-center gap-2" data-testid={`criterion-row-${i}`}>
          <input
            value={c.label || ""} onChange={(e) => update(i, { label: e.target.value.slice(0, 80) })}
            disabled={disabled}
            className="flex-1 bg-black/40 border border-white/15 rounded px-2 py-1 text-xs text-white focus:outline-none focus:border-fuchsia-400/70 disabled:opacity-50"
            data-testid={`criterion-label-${i}`}
            placeholder="Criterion label (e.g. Cadence/Flow)"
          />
          <label className="flex items-center gap-1 text-[10px] text-gray-400">
            ×
            <input
              type="number" min={1} max={10} value={c.weight || 1}
              onChange={(e) => update(i, { weight: Math.max(1, Math.min(10, parseInt(e.target.value, 10) || 1)) })}
              disabled={disabled}
              className="w-12 bg-black/40 border border-white/15 rounded px-1 py-1 text-xs text-white text-center focus:outline-none focus:border-fuchsia-400/70 disabled:opacity-50"
              data-testid={`criterion-weight-${i}`}
            />
          </label>
          <button
            type="button" onClick={() => remove(i)} disabled={disabled}
            className="text-red-300 hover:text-red-200 text-[10px] px-1 disabled:opacity-30"
            data-testid={`criterion-remove-${i}`}
          >Remove</button>
        </div>
      ))}
      <div className="flex items-center gap-3">
        <button
          type="button" onClick={add} disabled={disabled || criteria.length >= 6}
          className="px-2 py-1 rounded border border-fuchsia-500/40 text-fuchsia-200 text-[11px] font-bold hover:bg-fuchsia-500/10 disabled:opacity-30"
          data-testid="criteria-add-btn"
        >＋ Add criterion ({criteria.length}/6)</button>
        <span className="text-[10px] text-gray-500">Scale: {scale.min}–{scale.max}</span>
      </div>
    </div>
  );
}
